var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  style: {
    fill: "#212e60"
  }
}), /*#__PURE__*/React.createElement("g", {
  style: {
    fill: "#fff"
  }
}, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 18,
  r: 1
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.6 12.6q-.6.3-.6.9v.4c0 .6-.4 1-1 1s-1-.4-1-1v-.4c0-1.2.7-2.2 1.7-2.7s1.8-1.7 1.8-2.3C14.5 7.1 13.4 6 12 6S9.5 7.1 9.5 8.5s-.4 1-1 1-1-.4-1-1C7.5 6 9.5 4 12 4s4.5 2 4.5 4.5-1.2 3.3-2.9 4.1"
}))));
export { SvgInfo as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iYm9sZCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI5LjguMiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDIuMS4xIEJ1aWxkIDMpICAtLT4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNpcmNsZSB7CiAgICAgICAgZmlsbDogIzIxMkU2MDsKICAgICAgfQogICAgICAucXVlc3Rpb24gewogICAgICAgIGZpbGw6ICNmZmY7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDwhLS0gQ2lyY2xlIGJhY2tncm91bmQgLS0+CiAgPGNpcmNsZSBjbGFzcz0iY2lyY2xlIiBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiLz4KICA8IS0tIFF1ZXN0aW9uIG1hcmsgLS0+CiAgPGcgY2xhc3M9InF1ZXN0aW9uIj4KICAgIDxjaXJjbGUgY3g9IjEyIiBjeT0iMTgiIHI9IjEiLz4KICAgIDxwYXRoIGQ9Ik0xMy42LDEyLjZjLS40LjItLjYuNS0uNi45di40YzAsLjYtLjQsMS0xLDFzLTEtLjQtMS0xdi0uNGMwLTEuMi43LTIuMiwxLjctMi43LDEtLjUsMS44LTEuNywxLjgtMi4zLDAtMS40LTEuMS0yLjUtMi41LTIuNXMtMi41LDEuMS0yLjUsMi41LS40LDEtMSwxLTEtLjQtMS0xYzAtMi41LDItNC41LDQuNS00LjVzNC41LDIsNC41LDQuNS0xLjIsMy4zLTIuOSw0LjFaIi8+CiAgPC9nPgo8L3N2Zz4=";